import {
  AlertCircle,
  Ban,
  CheckCircle,
  CircleSlash,
  Copy,
  Hourglass,
  Loader2,
  type LucideIcon,
  Network,
  RotateCw,
  XCircle,
} from "lucide-react";

import type { ItemStatus } from "@/types/tina";

export interface StatusAccent {
  label: string;
  icon: LucideIcon;
  iconSpin?: boolean;
  stripe: string;
  iconWrap: string;
  iconColor: string;
}

export const STATUS_ACCENT: Record<ItemStatus, StatusAccent> = {
  pending: {
    label: "Pending",
    icon: Hourglass,
    stripe: "bg-muted-foreground/40",
    iconWrap: "bg-muted",
    iconColor: "text-muted-foreground",
  },
  in_progress: {
    label: "Running",
    icon: Loader2,
    iconSpin: true,
    stripe: "bg-blue-500",
    iconWrap: "bg-blue-500/10",
    iconColor: "text-blue-600 dark:text-blue-400",
  },
  waiting_on_primary: {
    label: "Waiting on primary",
    icon: Network,
    stripe: "bg-violet-500",
    iconWrap: "bg-violet-500/10",
    iconColor: "text-violet-600 dark:text-violet-400",
  },
  failed_retryable: {
    label: "Retrying",
    icon: RotateCw,
    iconSpin: true,
    stripe: "bg-amber-500",
    iconWrap: "bg-amber-500/10",
    iconColor: "text-amber-600 dark:text-amber-400",
  },
  failed: {
    label: "Failed",
    icon: XCircle,
    stripe: "bg-red-500",
    iconWrap: "bg-red-500/10",
    iconColor: "text-red-600 dark:text-red-400",
  },
  done: {
    label: "Done",
    icon: CheckCircle,
    stripe: "bg-emerald-500",
    iconWrap: "bg-emerald-500/10",
    iconColor: "text-emerald-600 dark:text-emerald-400",
  },
  skipped: {
    label: "Skipped",
    icon: CircleSlash,
    stripe: "bg-zinc-400",
    iconWrap: "bg-zinc-400/10",
    iconColor: "text-zinc-600 dark:text-zinc-400",
  },
  duplicate: {
    label: "Duplicate",
    icon: Copy,
    stripe: "bg-indigo-500",
    iconWrap: "bg-indigo-500/10",
    iconColor: "text-indigo-600 dark:text-indigo-400",
  },
  cancelled: {
    label: "Cancelled",
    icon: Ban,
    stripe: "bg-sky-500",
    iconWrap: "bg-sky-500/10",
    iconColor: "text-sky-600 dark:text-sky-400",
  },
  hitl: {
    label: "Needs review",
    icon: AlertCircle,
    stripe: "bg-orange-500",
    iconWrap: "bg-orange-500/10",
    iconColor: "text-orange-600 dark:text-orange-400",
  },
};
